import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

// checks if user is authorized to see a page.
const Authorized = (props) => {
  const user = useSelector((state) => state.auth.user);
  let history = useHistory();

  const checkAuthorization = () => {
    console.log("checkAuthorization: ");
    if (user._id) {
      return null;
    } else {
      history.push("/");
    }
  };

  useEffect(() => {
    checkAuthorization(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return props.render();
};

export default Authorized;
